// extracted by mini-css-extract-plugin
export var aiStarIcon = "_k0-2";
export var container = "_k0-4";
export var dismissButton = "_k0-3";
export var hasPaddingBottom = "_k0-6";
export var last = "_k0-e";
export var scrollbarThumb = "_k0-c";
export var scrollbarTrack = "_k0-b";
export var selected = "_k0-9";
export var spin = "_k0-1";
export var spinning = "_k0-0";
export var suggestionItem = "_k0-d";
export var suggestionsPanel = "_k0-5";
export var tonePill = "_k0-8";
export var tonesContainer = "_k0-7";
export var unselected = "_k0-a";